import { isOurStorySection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { useTranslation } from 'next-i18next';
import { useWeddingWebsiteData } from '../../data/data-context';
import { MotifOrnament, MotifSectionHookProps } from './motif-section-hooks';

export const MotifStory = (hookProps: MotifSectionHookProps) => {
  const { t } = useTranslation('weddingWebsite');
  const { website } = useWeddingWebsiteData();
  const ourStory = website.sections.find(isOurStorySection);

  return (
    <section {...hookProps} className="bb-ww__section bb-ww__section--story">
      <MotifOrnament />
      <h2 className="bb-ww__section-title">{t('previewMode.tile.ourStory.title')}</h2>
      <p className="bb-ww__body">{ourStory?.data.value}</p>
    </section>
  );
};
